import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import Hls from 'hls.js';
import { useEffect, useMemo, useRef } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * HLSで動画を再生するためのコンポーネント
 * @param props
 * @constructor
 */
export const HlsPlayer = (props) => {
    const { autoPlay = false, className, controls = true, muted = false, src, } = props;
    const isSupportBrowser = useMemo(() => Hls.isSupported(), []);
    const videoRef = useRef(null);
    useEffect(() => {
        if (!isSupportBrowser || !videoRef.current) {
            return undefined;
        }
        const hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(videoRef.current);
        return () => {
            hls.removeAllListeners();
            hls.stopLoad();
        };
    }, [isSupportBrowser, src]);
    return (_jsx("div", Object.assign({ className: clsx('w-full', className) }, { children: isSupportBrowser ? (_jsx("video", { autoPlay: autoPlay, className: clsx('w-full'), controls: controls, muted: muted, ref: videoRef })) : (_jsx(Text, Object.assign({ isBold: true, size: 'xs' }, { children: "\u304A\u4F7F\u3044\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u306F\u52D5\u753B\u518D\u751F\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002" }))) })));
};
